import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import { RouterLink } from '../Link';

interface ISuggestionItem {
  $focused?: boolean;
}

export const SuggestionItem = styled(Link).withConfig({ componentId: 'sc-1uess6e-0' })<ISuggestionItem>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${size(1.5)};
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium);
    padding: ${size(0.5)} 0;
    position: relative;

    &:hover {
        &::after {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: ${size(-1)};
            right: ${size(-1)};
            background-color: var(--c-bg-alt);
            border-radius: ${(props) => props.theme.size.borderRadius};
            z-index: -1;
        }
    }

    ${({ $focused }) =>
      $focused &&
      css`
            &::before {
                content: "";
                position: absolute;
                top: 0;
                bottom: 0;
                left: ${size(-1)};
                right: ${size(-1)};
                background-color: var(--c-bg-alt);
                border-radius: ${(props) => props.theme.size.borderRadius};
                z-index: -1;
            }
        `}
`;

export const SuggestionsListWrapper = styled.div.withConfig({ componentId: 'sc-1uess6e-1' })`
    border-top: 1px solid var(--c-bg-alt);
    flex: 0 0 100%;
    list-style: none;
    text-align: left;
    padding: ${size(2)} ${size(3)} ${size(3)};

    // Hide keyboard focus indicator when hovering with the cursor
    &:has(${SuggestionItem}:hover) {
        ${SuggestionItem}::before {
            content: none;
        }
    }
`;

export const SuggestionItemLabel = styled.span.withConfig({ componentId: 'sc-1uess6e-2' })`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SuggestionItemCount = styled.span.withConfig({ componentId: 'sc-1uess6e-3' })`
    font-weight: var(--font-weight-light);
    color: var(--c-text-muted);
`;

export const GroupHead = styled.div.withConfig({ componentId: 'sc-1uess6e-4' })`
    font-size: var(--font-size-xsmall);
    line-height: var(--line-height-xsmall);
    display: flex;

    ${SuggestionItem} + & {
        margin-top: ${size(3)};
    }
`;

export const GroupLabel = styled.div.withConfig({ componentId: 'sc-1uess6e-5' })`
    color: var(--c-text-muted);
    flex: 1 1 auto;
`;

export const GroupLink = styled(RouterLink).withConfig({ componentId: 'sc-1uess6e-6' })`
    flex: 0 0 auto;
`;
